import styled from 'styled-components';

const PageWrapper = styled.div`
	display: inline-block;
	width: 100%;
	display: flex;
`;

export default PageWrapper;
